import { render, staticRenderFns } from "./AccountReceived.vue?vue&type=template&id=c0a847ec"
import script from "./AccountReceived.vue?vue&type=script&lang=js"
export * from "./AccountReceived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports